export const AGE_GATE = {
  root: "age-gate-modal",
  checkbox: "age-gate-checkbox",
  confirmButton: "age-gate-confirm-button",
  exitLink: "age-gate-exit-link",
};

export const LANDING = {
  root: "landing-root",
  hero: "landing-hero",
  ctaPrimary: "landing-cta-primary",
  ctaSecondary: "landing-cta-secondary",
  statLive: "landing-stat-live",
  statPosts: "landing-stat-posts",
  statCommunities: "landing-stat-communities",
  statMembers: "landing-stat-members",
};

export const NAV = {
  logoLink: "nav-logo-link",
  feedLink: "nav-feed-link",
  liveLink: "nav-live-link",
  communitiesLink: "nav-communities-link",
  notificationsLink: "nav-notifications-link",
  profileLink: "nav-profile-link",
  composeButton: "nav-compose-button",
  goLiveButton: "nav-golive-button",
};

export const FEED = {
  root: "feed-root",
  post: (id) => `post-card-${id}`,
  likeButton: (id) => `post-like-button-${id}`,
  giftButton: (id) => `post-gift-button-${id}`,
  commentButton: (id) => `post-comment-button-${id}`,
};

export const COMPOSER = {
  root: "composer-root",
  textarea: "composer-textarea",
  submit: "composer-submit-button",
  communitySelect: "composer-community-select",
};

export const LIVE = {
  root: "live-root",
  card: (id) => `live-card-${id}`,
  goLiveTitle: "golive-title-input",
  goLiveSubmit: "golive-submit-button",
  goLiveClose: "golive-close-button",
  goLivePreview: "golive-preview-video",
  action: {
    flip: "golive-action-flip",
    beauty: "golive-action-beauty",
    filter: "golive-action-filter",
    paidLive: "golive-action-paid-live",
    split: "golive-action-split",
    customGifts: "golive-action-custom-gifts",
    poll: "golive-action-poll",
    goal: "golive-action-goal",
    wheel: "golive-action-wheel",
    extensions: "golive-action-extensions",
  },
  paidLiveInput: "golive-paid-entry-input",
  goalInput: "golive-goal-input",
  pollQuestion: "golive-poll-question-input",
  pollOption: (i) => `golive-poll-option-${i}-input`,
  wheelSegment: (i) => `golive-wheel-segment-${i}-input`,
  sheetSave: "golive-sheet-save-button",
  sheetClose: "golive-sheet-close-button",
};

export const COMMUNITIES = {
  root: "communities-root",
  card: (id) => `community-card-${id}`,
  joinButton: (id) => `community-join-button-${id}`,
};

export const PROFILE = {
  root: "profile-root",
  editButton: "profile-edit-button",
  saveButton: "profile-save-button",
  displayNameInput: "profile-display-name-input",
  bioInput: "profile-bio-input",
};

export const NOTIFICATIONS = {
  root: "notifications-root",
  item: (id) => `notification-item-${id}`,
  markAll: "notifications-mark-all-button",
};
